import {useEffect, useState} from 'react';
import {useNavigation} from '@react-navigation/native';

import {safeLayoutAnimation} from '/util/animation.util';

export const useAcceptDeclineBanner = ({
  updateCandidateStatus,
  getCandidateDeclineReasons,
  hasDeclineReasons,
}: any) => {
  const navigation = useNavigation();

  const [expanded, setExpanded] = useState(true);
  const [isAcceptPressed, setIsAcceptPressed] = useState(false);
  const [isDeclinePressed, setIsDeclinePressed] = useState(false);

  const onAcceptPress = async () => {
    setIsAcceptPressed(true);
    await updateCandidateStatus({status: 'A'});
  };

  const handleDeclineCandidate = async (declineReason: any) => {
    setIsDeclinePressed(true);
    const {reasonTypeId, reasonDescription, otherReason} = declineReason;
    const updateCandidateDataWithDeclineReason = {
      status: 'D',
      reason:
        reasonTypeId === 'RD4' && otherReason ? otherReason : reasonDescription,
      reasonTypeId: reasonTypeId,
    };
    await updateCandidateStatus(updateCandidateDataWithDeclineReason);

    navigation.goBack();
  };

  const toggleExpand = () => {
    safeLayoutAnimation();
    setExpanded(!expanded);
  };

  useEffect(() => {
    if (!hasDeclineReasons) {
      getCandidateDeclineReasons();
    }
  }, [hasDeclineReasons, getCandidateDeclineReasons]);

  return {
    toggleExpand,
    expanded,
    onAcceptPress,
    isAcceptPressed,
    isDeclinePressed,
    handleDeclineCandidate,
  };
};
